export function Initialize(toiConfig) {
    const getToiProvider = (key) => {
		const config = toiConfig[key];
		
        if (!config) {
            throw new Error(`No se encontro configuracion de TOI para la key: ${key}`);
        }

        let actualToi = undefined;
		
		if (config.unico) {
			actualToi = config.unico;
		}
		else {
			actualToi = config.desde;
		}
		
        const getToiValue = () => {
            if (config.unico) {
                return actualToi;
            }
			else {
                if (config.excluidos) {
                    while (config.excluidos.includes(actualToi)) {
                        actualToi++;
                    }
                }

                if (actualToi > config.hasta) {
                    throw new Error(`Se excedio la cantidad de TOIS solicitados para la configuracion: ${key}`);
                }
				
				return actualToi++;
            }
        };
		
		return { getToiValue };
    };
	
    return { getToiProvider };
}


// WEBPACK FOOTER //
// ./Statics/scripts/Core/Toi/ToiProvider.js